import { type MRT_ColumnDef, type MRT_RowData } from "mantine-react-table-open";
import { MantineYesNoRadioGroup } from "../../../../../../mantine/mrt/components/cell/MantineYesNoRadioGroup";
import { ControlledMantineEditYesNoRadioGroup } from "../../../../../../mantine/mrt/components/edit/ControlledMantineEditYesNoRadioGroup";
import type { Meter } from "../../../../SiteSetupAssistant.types";
import { getMeterTableErrorText } from "../getMeterTableErrorText";

export function getIsCalibratedColumn<T extends MRT_RowData>(
  getCellError: (
    rowIndex: number,
    accessorKey: keyof Meter
  ) => Array<string> | null | undefined
): MRT_ColumnDef<T> {
  return {
    accessorKey: "is_calibrated",
    header: "Zähler geeicht?",
    Edit: ({ row, cell, column }) => (
      <ControlledMantineEditYesNoRadioGroup
        allowInput
        cell={cell}
        columnId={column.id}
        errorText={undefined}
        row={row}
      />
    ),
    Cell: ({ row }) => {
      const cellError = getCellError(row.index, "is_calibrated");
      return (
        <MantineYesNoRadioGroup
          allowInput={false}
          checked={row.original.is_calibrated}
          errorText={
            cellError ? getMeterTableErrorText(cellError[0]) : undefined
          }
        />
      );
    }
  };
}
